import { Badge } from '@mui/material';
import React from 'react';

const SearchFilterBadge = props => (
  <Badge
    color="error"
    sx={{
      '& .MuiBadge-badge': {
        top: -6,
        right: -2,
        transform: 'none',
        height: 16,
        minWidth: 16,
        borderRadius: '50%',
        fontSize: '10px',
        padding: 0
      }
    }}
    {...props}
  />
);

export default SearchFilterBadge;
